var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorRedExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E44437"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9511 49.7904L35.2151 24.1984H45.6311L43.8951 49.7904H36.9511ZM40.4231 63.8464C38.8551 63.8464 37.5671 63.3424 36.5591 62.3344C35.5511 61.3264 35.0471 60.1318 35.0471 58.7504C35.0471 57.3318 35.5511 56.1558 36.5591 55.2224C37.5671 54.2518 38.8551 53.7664 40.4231 53.7664C42.0285 53.7664 43.3165 54.2518 44.2871 55.2224C45.2951 56.1558 45.7991 57.3318 45.7991 58.7504C45.7991 60.1318 45.2951 61.3264 44.2871 62.3344C43.3165 63.3424 42.0285 63.8464 40.4231 63.8464Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRedExclamation);
export default __webpack_public_path__ + "static/media/error_red_exclamation.75d71f999e05690b86236ee1210e04e5.svg";
export { ForwardRef as ReactComponent };